import {
	Component,
	EventEmitter,
	Output,
	ViewChild,
	ChangeDetectionStrategy,
} from '@angular/core';
import { LegacyApiService } from '@lmc-app/core/services/legacy-api.service';
import { MatPaginator } from '@angular/material/paginator';
import {
	MatTableDataSource,
	MatTable,
	MatColumnDef,
	MatHeaderCellDef,
	MatHeaderCell,
	MatCellDef,
	MatCell,
	MatHeaderRowDef,
	MatHeaderRow,
	MatRowDef,
	MatRow,
} from '@angular/material/table';
import { Subscription } from 'rxjs';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { RouterLink } from '@angular/router';

@Component({
	selector: 'app-aob',
	templateUrl: './aob.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styles: [
		'table {display:block; margin-bottom:1em}',
		'.mat-mdc-table {width: 100%;max-height: 500px;overflow: auto;}',
		'tr.element-row:hover{background: whitesmoke}',
		'a {text-decoration: none;}',
		'.loading-shade {position: absolute;top: 0;left: 0;bottom: 56px;right: 0;background: rgba(136, 134, 134, 0.15);z-index: 1;display: flex;align-items: center;justify-content: center;}',
	],
	imports: [
		NgIf,
		MatProgressSpinner,
		MatTable,
		MatColumnDef,
		MatHeaderCellDef,
		MatHeaderCell,
		MatCellDef,
		MatCell,
		RouterLink,
		MatHeaderRowDef,
		MatHeaderRow,
		MatRowDef,
		MatRow,
		MatPaginator,
	],
})
export class AobComponent {
	@ViewChild('paginator') paginator: MatPaginator;
	@Output() sendAOB = new EventEmitter<any>();
	constructor(private apiService: LegacyApiService) {}
	aobColumns: string[] = ['name', 'province', 'agencyName', 'note'];
	dataSourceAOB: MatTableDataSource<string[]>;
	isLoading = true;
	totalAOB: number;
	serviceSubscription: Subscription;
	async ngAfterViewInit(): Promise<void> {
		this.dataSourceAOB = new MatTableDataSource(await this.aobStage(['AOB']));
		this.dataSourceAOB.paginator = this.paginator;
		this.totalAOB = this.dataSourceAOB.filteredData
			?.map((item: any) => item.Amount)
			.reduce((prev, next) => prev + next, 0);
		this.sendTotalCountandAmount(
			this.dataSourceAOB?.filteredData.length,
			this.totalAOB
		);
	}
	aobStage(stageName): Promise<any> {
		return new Promise((resolve, reject) => {
			this.isLoading = true;
			this.serviceSubscription = this.apiService
				.underwritingDashboardQueues(stageName)
				.subscribe((res: any) => {
					if (res.message.statusCode === 200) {
						const arr = JSON.parse(res.message.body);
						this.isLoading = false;
						resolve(arr.data);
					} else {
						this.isLoading = false;
						resolve([]);
					}
				});
		});
	}

	sendTotalCountandAmount(count: number, amount: number) {
		const result = { count: count, amount: amount };
		this.sendAOB.emit(result);
	}

	ngOnDestroy() {
		this.serviceSubscription.unsubscribe();
	}
}
